module.exports = __webpack_public_path__ + "static/TT1355_TW-MARK-D01a-clean-da026cab7fbbbc6a1bc348b9d653c606.png";